export const defaultEdgeStyle = { stroke: "#EF4158" };
